import React, { FC, useState } from 'react';
import { IonItem, IonLabel } from '@ionic/react';
import { chevronDown } from 'ionicons/icons';
import {
  RotatingIcon,
  CollapsibleContent,
  CardContainer,
  StyledItem,
} from './CollapsibleCard.styles';
import { AllieText } from '../../../components';

interface AllieCollapsibleCardProps {
  title?: string | React.ReactNode;
  isCollapsible?: boolean;
  children: React.ReactNode;
  initialState?: boolean;
  iconWidth?: string | number; // Add optional icon width
  style?: React.CSSProperties;
  fullWidth?: boolean; // Nueva prop para controlar el ancho completo
  overflow?: boolean; // Nueva prop para controlar el overflow
}

export const AllieCollapsibleCard: FC<AllieCollapsibleCardProps> = ({
  title,
  children,
  isCollapsible,
  initialState = false,
  iconWidth,
  style,
  fullWidth = false,
  overflow = false, // Nueva prop para controlar el overflow
}) => {
  const [isOpen, setIsOpen] = useState(initialState);

  if (!isCollapsible) {
    return <CardContainer style={style} $fullWidth={fullWidth}>{children}</CardContainer>;
  }

  const renderTitle = () => {
    if (React.isValidElement(title)) {
      return title;
    }
    return <AllieText type="h5">{title}</AllieText>;
  };

  return (
    <CardContainer style={style} $fullWidth={fullWidth}>
      <StyledItem mode="md" lines="none" button onClick={() => setIsOpen(!isOpen)}>
        {renderTitle()}
        <RotatingIcon
          icon={chevronDown}
          slot="end"
          isOpen={isOpen}
          style={{ width: iconWidth ? { width: iconWidth } : undefined }}
        />
      </StyledItem>
      <CollapsibleContent
        isOpen={isOpen}
        $fullWidth={fullWidth}
        $overflow={overflow}
      >
        {children}
      </CollapsibleContent>
    </CardContainer>
  );
};
